import { useEffect, useState } from "react";
import { Menu, ShoppingBag } from "lucide-react";
import logo from "../../assets/logoCold2.png";
import { useNavigate } from "react-router-dom";
import salvavidas from "../../assets/salvavidas.png"

export default function Navbar({ setIsCartOpen, isCartOpen }) {
  const navigate = useNavigate();
  const [hasBackground, setHasBackground] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setHasBackground(true);
      } else {
        setHasBackground(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`w-full h-24 flex z-50 items-center fixed top-0 justify-around transition-all duration-300 ${
        hasBackground
          ? "backdrop-filter backdrop-blur-lg bg-opacity-30 bg-white"
          : "bg-transparent"
      }`}
    >
      <img className="w-[90px]" src={logo} alt="" />
      <div className="text-mandarin flex gap-6 font-semibold text-2xl">
        <p className="uppercase sm:block hidden ">Guadalajara</p>
      </div>
      <div className="sm:hidden block" >
        <Menu className="w-10 h-10 text-mandarin " />
      </div>
      
      <div className="sm:block hidden" >
      <img className="w-12 h-7" src={salvavidas} alt="" />
      </div>
    </div>
  );
}